import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenFieldProps, ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const RangeTo = ({ codeItem, updateByKey, resetValidation,  readOnlyConfig, translation, validation }: ScreenFieldProps) => {

  const onChange = (value: number) => {
    resetValidation(ScreenField.rangeTo);
    updateByKey(ScreenField.rangeTo, value);
  };

  const rangeToValidation = !!validation && !!validation.rangeTo ? validation.rangeTo : undefined;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId={ScreenField.rangeTo}
      readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.all]}
      label={{ text: translation.range_to }}
      value={codeItem && codeItem.rangeTo}
      validation={rangeToValidation}
      onChange={onChange}
      useThousand=" "
      minValue={0}
      textInvalidRangeError={translation.must_be_within_range}
      maxValue={999999999}
      maxDecimals={0}
    />
  </div>;
};
